import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-wordpress-dev',
  templateUrl: './custom-wordpress-dev.component.html',
  styleUrls: ['./custom-wordpress-dev.component.css']
})
export class CustomWordpressDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/custom-wordpress-dev/custom-wordpress-dev.component.ts